import * as THREE from "three";
import "three";
export class AssetManager {
    constructor() {
        this.loaded = false;
        this.onLoaded = [];
        this.manager = new THREE.LoadingManager();
        this.manager.onLoad = () => {
            this.loaded = true;
            this.onLoaded.forEach((onLoaded) => {
                onLoaded();
            });
            this.onLoaded = undefined;
        };
    }
    ensureLoaded(onLoaded) {
        if (this.loaded == true)
            onLoaded();
        else
            this.onLoaded.push(onLoaded);
    }
}
export const assets = new AssetManager();
export let textFont;
export const groundColor = new THREE.TextureLoader(assets.manager).load(`/mat/ground/color.jpg`, (texture) => {
    groundColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const groundRoughness = new THREE.TextureLoader(assets.manager).load(`/mat/ground/roughness.jpg`, (texture) => {
    groundRoughness.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const groundNormal = new THREE.TextureLoader(assets.manager).load(`/mat/ground/normal.jpg`, (texture) => {
    groundNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const pillarColorWhite = new THREE.TextureLoader(assets.manager).load("/mat/pillar/color_2.jpg", (texture) => {
    pillarColorWhite.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const pillarColorGray = new THREE.TextureLoader(assets.manager).load("/mat/pillar/color.jpg", (texture) => {
    pillarColorGray.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const pillarRoughness = new THREE.TextureLoader(assets.manager).load("/mat/pillar/roughness.jpg", (texture) => {
    pillarRoughness.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const pillarRoughness2 = new THREE.TextureLoader(assets.manager).load("/mat/pillar/roughness_2.jpg", (texture) => {
    pillarRoughness2.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const fabricCoverNormal = new THREE.TextureLoader(assets.manager).load("/mat/pillar/fabric_cover_normal.jpg", (texture) => {
    fabricCoverNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const wallColor = new THREE.TextureLoader(assets.manager).load("/mat/wall/color.jpg", (texture) => {
    wallColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const wallRoughness = new THREE.TextureLoader(assets.manager).load("/mat/wall/roughness.jpg", (texture) => {
    wallRoughness.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const wallNormal = new THREE.TextureLoader(assets.manager).load("/mat/wall/normal.jpg", (texture) => {
    wallNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const fabricColor = new THREE.TextureLoader(assets.manager).load("/mat/fabric/color.jpg", (texture) => {
    fabricColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const fabricNormal = new THREE.TextureLoader(assets.manager).load("/mat/fabric/normal.jpg", (texture) => {
    fabricNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const sliderNormal = new THREE.TextureLoader(assets.manager).load("/mat/slider/slider_normal.png", (texture) => {
    sliderNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const glassColor = new THREE.TextureLoader(assets.manager).load("/mat/glass/color.jpg", (texture) => {
    glassColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const glassAlpha = new THREE.TextureLoader(assets.manager).load("/mat/glass/alpha.jpg", (texture) => {
    glassAlpha.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const glassNormal = new THREE.TextureLoader(assets.manager).load("/mat/glass/normal.png", (texture) => {
    glassNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const glassAoMap = new THREE.TextureLoader(assets.manager).load("/mat/glass/ao.png", (texture) => {
    glassAoMap.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const panelNormal = new THREE.TextureLoader(assets.manager).load("/mat/panel/panelNormal.jpg", (texture) => {
    panelNormal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const panelColor = new THREE.TextureLoader(assets.manager).load("/mat/metal/color.jpg", (texture) => {
    panelColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const panelMetal = new THREE.TextureLoader(assets.manager).load("/mat/metal/metal.jpg", (texture) => {
    panelMetal.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const panelRoughness = new THREE.TextureLoader(assets.manager).load("/mat/metal/roughness.jpg", (texture) => {
    panelRoughness.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const threeAxisLedAlpha = new THREE.TextureLoader(assets.manager).load("/mat/lights/three_axis_alpha.jpg", (texture) => {
    threeAxisLedAlpha.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
});
export const threeAxisLedAlphaRotated = new THREE.TextureLoader(assets.manager).load("/mat/lights/three_axis_alpha_rotated.jpg", (texture) => {
    threeAxisLedAlphaRotated.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
});
export const zipColor = new THREE.TextureLoader(assets.manager).load("/mat/fabric/zipscreen.jpg", (texture) => {
    zipColor.wrapS = texture.wrapT = THREE.RepeatWrapping;
});
export const zipNormal = new THREE.TextureLoader(assets.manager).load("/mat/zip/normal.png", (texture) => {
    zipNormal.wrapS = texture.wrapT = THREE.ClampToEdgeWrapping;
});
export const insulatedSprite = new THREE.TextureLoader(assets.manager).load("/img/insulated-panel-ic.png");
export const envMap = new THREE.TextureLoader(assets.manager).load("/mat/envMap/env.jpg", (texture) => {
    texture.mapping = THREE.EquirectangularReflectionMapping;
    texture.encoding = THREE.sRGBEncoding;
});
export const loadText = new THREE.FontLoader(assets.manager).load("/fonts/font.json", (font) => {
    textFont = font;
});
